import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export default function useOnlineStatus() {
  const [online, setOnline] = useState(true);
  const handleOnline = () => {
    setOnline(true);
    toast.success("You're online", {
      className: 'toast-online',
    });
  };
  const handleOffline = () => {
    setOnline(false);
    toast.error("You're offline", {
      className: 'toast-online',
    });
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);
    }

    return () => {
      if (window) {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
      }
    };
  }, []);

  return {
    online,
  };
}
